module.exports = __webpack_public_path__ + "img/ru7m.5775745f.jpg";